module.exports = __webpack_public_path__ + "img/Python32.cdf39212.svg";